import FormattedMessage from 'I18n/components/FormattedMessage';
import { sortApiNamesByProductLevel } from 'pricing-pages-lib/utils/sortingUtils';
import styled from 'styled-components';
import GenericBundleFeatureTableHeaderCell from './GenericBundleFeatureTableHeaderCell';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StaticTable = styled.table.withConfig({
  displayName: "GenericBundleFeatureTableHeader__StaticTable",
  componentId: "sc-10uzpji-0"
})(["margin-bottom:0;"]);
const THead = styled.thead.withConfig({
  displayName: "GenericBundleFeatureTableHeader__THead",
  componentId: "sc-10uzpji-1"
})(["height:155px;vertical-align:bottom;& tr th:first-of-type{font-size:1.5rem;font-weight:600;text-align:left;border:none !important;}"]);
const GenericBundleFeatureTableHeader = ({
  levels,
  apiNames,
  location,
  screen
}) => {
  const sortedApiNames = sortApiNamesByProductLevel(apiNames);
  return /*#__PURE__*/_jsx(StaticTable, {
    children: /*#__PURE__*/_jsx(THead, {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          className: "p-bottom-3 p-left-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.productCatalog.tableHeader.features"
          })
        }), levels.map((level, index) => {
          return /*#__PURE__*/_jsx(GenericBundleFeatureTableHeaderCell, {
            productLevel: level,
            columns: levels.length,
            location: location,
            apiName: sortedApiNames[index],
            screen: screen
          }, level);
        })]
      })
    })
  });
};
export default GenericBundleFeatureTableHeader;